import { Clock, ShieldAlert, UserCheck, Users } from "lucide-react";
import { Card, CardContent } from "@/components/ui/card";
import { Skeleton } from "@/components/ui/skeleton";
import { useOverviewStats } from "@/hooks/useOverviewStats";

const tiles = [
	{
		key: "clientCount" as const,
		label: "Clients",
		icon: Users,
		color: "text-clyr-blue-400",
	},
	{
		key: "activeCount" as const,
		label: "Active",
		icon: UserCheck,
		color: "text-green-400",
	},
	{
		key: "pendingCount" as const,
		label: "Pending Activation",
		icon: Clock,
		color: "text-amber-400",
	},
	{
		key: "blockedCount" as const,
		label: "Blocked",
		icon: ShieldAlert,
		color: "text-red-400",
	},
];

export const OverviewPage = () => {
	const { data: stats, isLoading } = useOverviewStats();

	return (
		<div className="space-y-6">
			<h1 className="text-2xl font-bold text-white">Overview</h1>
			<div className="grid grid-cols-4 gap-4">
				{tiles.map((tile) => (
					<Card
						key={tile.key}
						className="bg-clyr-gray-800 rounded-lg border-clyr-gray-700"
					>
						<CardContent className="p-4">
							<div className="flex items-center justify-between mb-2">
								<span className="text-xs uppercase text-clyr-gray-400">
									{tile.label}
								</span>
								<tile.icon className={`h-4 w-4 ${tile.color}`} />
							</div>
							{isLoading ? (
								<Skeleton className="h-8 w-16" />
							) : (
								<div className="text-2xl font-bold text-white">
									{stats?.[tile.key]?.toLocaleString() ?? "0"}
								</div>
							)}
						</CardContent>
					</Card>
				))}
			</div>
		</div>
	);
};
